import { useEffect } from 'react';
import { Button } from '../typography/button/button';
import { CONTACT_FORM_CLASSNAME } from '../contact-me/contact-me';

type BannerProps = {
    link?: {
        title: string;
        url: string;
        target: string;
    };
    text?: string;
    title?: string;
    onDismiss: () => void;
};

export const Banner = ({ link, text, title, onDismiss }: BannerProps) => {
    useEffect(() => {
        if (!document.body.classList.contains(CONTACT_FORM_CLASSNAME)) {
            document.body.classList.add(CONTACT_FORM_CLASSNAME);
        }

        return () => {
            document.body.classList.remove(CONTACT_FORM_CLASSNAME);
        };
    }, []);

    return (
        <div
            data-component="banner"
            className="r-fixed r-bottom-4 r-left-4 r-right-4 r-z-[1001] r-flex r-max-h-[calc(100vh-4rem)] r-flex-col r-items-center r-justify-between r-rounded-2xl r-bg-white/95 r-p-4 r-text-black r-shadow-[0_2px_16px_0_rgba(0,0,0,.15)] sm:r-bottom-8 sm:r-left-8 sm:r-right-8 sm:r-translate-x-0 sm:r-translate-y-0 md:r-left-auto md:r-min-w-[528px] md:r-px-8"
        >
            <button aria-label="Close" onClick={() => onDismiss()} className="r-absolute -r-left-2 -r-top-2 r-rounded-full r-bg-white/95">
                <svg className="r-size-8" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M20.7063 19.2945C21.0969 19.6852 21.0969 20.318 20.7063 20.7086C20.5125 20.9039 20.2563 21.0008 20 21.0008C19.7437 21.0008 19.4881 20.9031 19.2931 20.7078L16 17.4164L12.7072 20.707C12.5119 20.9039 12.2559 21.0008 12 21.0008C11.7441 21.0008 11.4884 20.9039 11.293 20.707C10.9023 20.3164 10.9023 19.6836 11.293 19.293L14.5867 15.9992L11.293 12.707C10.9023 12.3164 10.9023 11.6836 11.293 11.293C11.6836 10.9023 12.3164 10.9023 12.707 11.293L16 14.5883L19.2937 11.2945C19.6844 10.9039 20.3172 10.9039 20.7078 11.2945C21.0984 11.6852 21.0984 12.318 20.7078 12.7086L17.4141 16.0023L20.7063 19.2945Z"
                        fill="#212529"
                    />
                </svg>
            </button>
            <div className="r-w-full">
                <div className="r-container r-flex r-items-center r-justify-between r-gap-2">
                    <div>
                        <p className="r-text-balance r-font-bold md:r-text-xl">{title}</p>
                    </div>
                    <div>
                        <Button type="primary" size="small" to={link?.url || '/'} fullWidth>
                            {text}
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
};
